import { useState } from "react";
import type { SupportKind } from "@/api/client";
import { canCreate, SUPPORT_KINDS } from "./supportLogic";

// Форма нового обращения: тип, тема, сообщение (эталон: .sp-nw). «Создать
// обращение» неактивна, пока тема или текст пусты.

export function NewTicketForm({
  onCreate,
  onCancel,
}: {
  /** Создать обращение; вернуть текст ошибки или null. */
  onCreate: (kind: SupportKind, title: string, text: string) => Promise<string | null>;
  onCancel: () => void;
}) {
  const [kind, setKind] = useState<SupportKind>("question");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const can = canCreate(title, text) && !busy;

  async function submit() {
    if (!can) return;
    setBusy(true);
    setError(null);
    const problem = await onCreate(kind, title.trim(), text.trim());
    // При успехе форму закрывает родитель; здесь остаётся только ошибка.
    if (problem) {
      setError(problem);
      setBusy(false);
    }
  }

  return (
    <form
      className="sup-new"
      onSubmit={(e) => {
        e.preventDefault();
        void submit();
      }}
    >
      <div className="sup-lbl">ТИП ОБРАЩЕНИЯ</div>
      <select
        className="sup-input"
        value={kind}
        onChange={(e) => setKind(e.target.value as SupportKind)}
      >
        {SUPPORT_KINDS.map((k) => (
          <option key={k.value} value={k.value}>
            {k.label}
          </option>
        ))}
      </select>
      <div className="sup-lbl">ТЕМА</div>
      <input
        className="sup-input"
        placeholder="Коротко, о чём вопрос"
        maxLength={200}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <div className="sup-lbl">СООБЩЕНИЕ</div>
      <textarea
        className="sup-input"
        rows={6}
        maxLength={4000}
        placeholder="Опишите ситуацию"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      {error && (
        <div className="sup-err" role="alert" style={{ marginTop: 12 }}>
          {error}
        </div>
      )}
      <div className="sup-btns">
        <button type="submit" className="sup-create" disabled={!can}>
          Создать обращение
        </button>
        <button type="button" className="sup-cancel" onClick={onCancel}>
          Отмена
        </button>
      </div>
    </form>
  );
}
